import { ActiveProduct } from './actionTypes';

export const setActiveProduct = (activeProduct) => ({
    type: ActiveProduct.SET,
    activeProduct,
});

export const setPrime = (isPrime) => ({
    type: ActiveProduct.ISPRIME,
    payload: isPrime,
});
